export default "/images/51a96be25ac81e8b13b9be528e7806bf.avif";